import { motion } from "framer-motion";
import { CalendarCheck, ExternalLink } from "lucide-react";

const CAL_URL = "https://cal.com/informacion-disruptiva-ouxkg5/30min";

export const ScheduleSection = () => {
  return (
    <section id="schedule" className="relative py-32" data-testid="schedule-section">
      <div className="morph-bg w-[400px] h-[400px] bg-purple-700/8 top-[20%] right-[-8%]" />

      <div className="relative z-10 max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="pulse-dot" />
            <span className="text-[13px] text-white/35 font-space tracking-widest uppercase">Agenda tu reunión</span>
          </div>
          <h2 className="font-space font-bold text-4xl md:text-6xl text-white mb-4 leading-tight">
            Hablemos en<br />persona
          </h2>
          <p className="text-white/40 text-lg max-w-lg mx-auto">
            Reserva 30 minutos con nuestro equipo. Sin compromiso, directamente en tu calendario.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="glass-card overflow-hidden"
        >
          {/* Cal.com embed */}
          <div className="w-full" style={{ minHeight: "650px" }} data-testid="cal-embed">
            <iframe
              src={`${CAL_URL}?embed=true&theme=dark`}
              width="100%"
              height="650"
              frameBorder="0"
              title="Agendar reunión con Disruptiva"
              className="w-full rounded-xl"
              allow="camera; microphone"
              loading="lazy"
            />
          </div>

          {/* Fallback link */}
          <div className="px-8 py-5 border-t border-white/[0.04] flex items-center justify-between">
            <span className="text-sm text-white/30 font-space">
              ¿Problemas con el calendario?
            </span>
            <a
              href={CAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-purple-400/60 hover:text-purple-400 transition-colors font-space"
              data-testid="cal-external-link"
            >
              Abrir en Cal.com
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>
        </motion.div>

        {/* Direct CTA */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mt-8 text-center"
        >
          <p className="text-white/25 text-sm mb-4">O agenda directamente:</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={CAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              data-testid="cal-cta-button"
            >
              <CalendarCheck className="w-5 h-5" />
              Agendar en Cal.com
            </a>
            <a
              href="https://wa.me/50364330431"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-6 py-3 rounded-xl border border-white/[0.08] text-white/50 hover:text-white hover:border-white/[0.15] transition-all text-sm font-space"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WhatsApp
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
